import React from 'react';
import { WebsiteDesignProps } from './types';
import { Zap, BarChart2, Globe } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ModernSaaS: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "EduTech Solutions";

    return (
        <div className="bg-white min-h-screen font-sans text-slate-900">
             <nav className="container mx-auto px-6 py-6 flex justify-between items-center">
                 <div className="font-bold text-2xl tracking-tight flex items-center gap-2">
                     <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white">
                         <Zap size={18} fill="currentColor" />
                     </div>
                     {schoolName}
                 </div>
                 <div className="hidden md:flex items-center gap-8 font-medium text-slate-600">
                     <a href="#" className="hover:text-indigo-600">Product</a>
                     <a href="#" className="hover:text-indigo-600">Features</a>
                     <a href="#" className="hover:text-indigo-600">Marketplace</a>
                     <a href="#" className="hover:text-indigo-600">Company</a>
                 </div>
                 <div className="flex gap-4">
                     <Button variant="ghost" className="font-medium text-slate-600">Sign in</Button>
                     <Button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg px-6">Start Learning</Button>
                 </div>
             </nav>

             <main className="container mx-auto px-6 py-20 pb-32">
                 <div className="flex flex-col md:flex-row items-center gap-16">
                     <div className="md:w-1/2">
                         <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-sm font-semibold mb-6">
                             <span className="w-2 h-2 rounded-full bg-indigo-600"></span>
                             New v4.0 is live
                         </div>
                         <h1 className="text-5xl md:text-6xl font-extrabold text-slate-900 mb-6 leading-tight">
                             Master skills with <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">velocity.</span>
                         </h1>
                         <p className="text-xl text-slate-500 mb-8 leading-relaxed">
                             Our platform provides the infrastructure for high-velocity learning. Data-driven insights meet world-class curriculum.
                         </p>
                         <div className="flex gap-4 flex-col sm:flex-row">
                             <Button className="h-14 px-8 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-lg rounded-lg shadow-lg shadow-indigo-200">
                                 Get Started Free
                             </Button>
                             <Button variant="outline" className="h-14 px-8 border-slate-200 text-slate-700 font-semibold text-lg rounded-lg hover:bg-slate-50">
                                 View Documentation
                             </Button>
                         </div>
                         <div className="mt-8 text-sm text-slate-500 font-medium">
                             Trusted by engineering teams at top companies.
                         </div>
                     </div>
                     
                     <div className="md:w-1/2 relative">
                         <div className="absolute top-10 right-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
                         <div className="absolute top-10 left-10 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
                         
                         <div className="relative bg-white rounded-2xl shadow-2xl border border-slate-100 p-2 transform rotate-1 hover:rotate-0 transition-transform duration-500">
                             <div className="bg-slate-50 rounded-xl overflow-hidden border border-slate-100">
                                 <div className="h-8 bg-white border-b border-slate-100 flex items-center px-4 gap-2">
                                     <div className="w-3 h-3 rounded-full bg-red-400"></div>
                                     <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                                     <div className="w-3 h-3 rounded-full bg-green-400"></div>
                                 </div>
                                 <div className="p-8">
                                     <div className="flex justify-between items-end mb-8">
                                         <div>
                                             <div className="text-sm text-slate-500 font-bold uppercase tracking-wider mb-1">Progress</div>
                                             <div className="text-3xl font-extrabold text-slate-900">84%</div>
                                         </div>
                                         <BarChart2 className="text-indigo-600" />
                                     </div>
                                     <div className="space-y-3">
                                         <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
                                             <div className="h-full w-[84%] bg-indigo-600 rounded-full"></div>
                                         </div>
                                         <div className="h-2 bg-slate-200 rounded-full w-2/3"></div>
                                         <div className="h-2 bg-slate-200 rounded-full w-1/2"></div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </main>
        </div>
    );
};

export default ModernSaaS;
